import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';         ///----------- for searching pop up -----------



@Component({
  selector: 'app-doctorssearch',
  templateUrl: './doctorssearch.component.html',
  styleUrls: ['./doctorssearch.component.css']
})
export class DoctorssearchComponent implements OnInit {
  docCode = '';
  docName = '';
  docAddress = '';
  docPhone ='';
  docMobile = '';
  docmail ='';
  docDepartment = '';
  docTitle ='';
  docWPhone = '';
  docWMMobile = '';
  docWmail = '';
  docUser ='';
  compCode = '1';
  userID = '';
  modifiedDate = '2021-01-01';
  doctorsList: DoctorsModel [] = [];
  patientcode = '';
  @Output() submitClicked = new EventEmitter<any>();                    ///----------- for searching pop up -----------

  constructor(public dialogRef: MatDialogRef<DoctorssearchComponent>,   ///----------- for searching pop up -----------
              public doctorsService: DoctorsService,
              public doctors: DoctorsModel,
              public storage: LocalStorageService,
              @Inject(MAT_DIALOG_DATA) public data :any,                                  ///----------- for searching pop up -----------
              public doctorsSelectedData: DoctorsModel) {

                this.patientcode = data.type;
              }             ///----------- for searching pop up -----------

  ngOnInit(): void {

    if (this.patientcode =='' && this.storage.retrieve('stgcompCode') !='10'){ this.retriveDoctorsLookupTop()}
    if (this.patientcode !='' && this.storage.retrieve('stgcompCode') !='10'){this.retriveDoctorsInvoiceLookupTop()}
    if ( this.storage.retrieve('stgcompCode') =='10'){ this.retriveDoctorsLookupTop()}


  }

  retriveDoctorsLookup() {
    this.doctorsList = [];
    this.doctorsService.getDoctorsLookup(this.docCode,this.docName,this.compCode).subscribe((data: DoctorsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.doctorsList[i] = data[i];
      }
    })
  }
  retriveDoctorsLookupTop() {
    this.doctorsList = [];
    this.doctorsService.getDoctorsLookupTop(this.compCode).subscribe((data: DoctorsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.doctorsList[i] = data[i];
      }
    })
  }
retriveDoctorsInvoiceLookupTop(){
   this.doctorsList = [];
    this.doctorsService.getDoctorsInvoiceLookupTop(this.patientcode).subscribe((data: DoctorsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.doctorsList[i] = data[i];
      }
    })
}
  SelectDoctors(doctor: DoctorsModel){                              ///----------- for searching pop up send variables from table-----------
    this.doctorsSelectedData.docCode = doctor.docCode
    this.doctorsSelectedData.docName = doctor.docName
    this.doctorsSelectedData.docAddress = doctor.docAddress

    this.doctorsSelectedData.docDepartment = doctor.docDepartment
    this.doctorsSelectedData.docPhone = doctor.docPhone
    this.doctorsSelectedData.docMobile = doctor.docMobile
    this.doctorsSelectedData.docmail = doctor.docmail

    this.doctorsSelectedData.docTitle = doctor.docTitle
    this.doctorsSelectedData.docWPhone = doctor.docWPhone
    this.doctorsSelectedData.docWMMobile = doctor.docWMMobile
    this.doctorsSelectedData.docWmail = doctor.docWmail

    this.doctorsSelectedData.docUser = doctor.docUser

    this.doctorsSelectedData.userID = doctor.userID
    this.doctorsSelectedData.modifiedDate = doctor.modifiedDate
    this.doctorsSelectedData.compCode = doctor.compCode
    this.submitClicked.emit(this.doctorsSelectedData);
    this.dialogRef.close();
  }
}
